//@helpers
const { getEntitiesData, getGlobalPositionTink } = require('./aggregatorData');

const { APIGet, APIPost, APIPatch } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { fromJS } = require('immutable');
const { getPersonTypeAndCodeHashed } = require('utilities/hash');
import { cipherWithPublicKey } from 'utilities/eurobitsCipher';
const {
  AGGREGATOR_NEW_FEATURES,
  NOT_ALLOWED_TINK_AGGREGATOR,
} = require('constants/flagBasedFeatures');

import { sha512 } from 'utilities/hash';
const { getLanguage } = require('core/i18n').i18n;

//@constants
import {
  CHECK_BOX_CHECKED,
  MAKE_OFFERS_CHECK_BOX,
  THIRD_PARTIES_CHECK_BOX,
} from 'constants/aggregator/aggregatorAddEntityModal.constants';

import {
  AGGREGATOR_ADD_ENTITY_VALIDATE_STEP,
  AGGREGATOR_ADD_ENTITY_SELECT_BANK,
  AGGREGATOR_ADD_ENTITY_GET_BANKS_REQUEST,
  AGGREGATOR_ADD_ENTITY_GET_BANKS_SUCCESS,
  AGGREGATOR_ADD_ENTITY_GET_BANKS_FAILURE,
  AGGREGATOR_ADD_ENTITY_GET_FORM_REQUEST,
  AGGREGATOR_ADD_ENTITY_GET_FORM_SUCCESS,
  AGGREGATOR_ADD_ENTITY_GET_FORM_FAILURE,
  AGGREGATOR_ADD_ENTITY_SET_FORM_VALUE,
  AGGREGATOR_ADD_ENTITY_SEND_FORM_INFO_REQUEST,
  AGGREGATOR_ADD_ENTITY_SEND_FORM_INFO_SUCCESS,
  AGGREGATOR_ADD_ENTITY_SEND_FORM_INFO_FAILURE,
  AGGREGATOR_ADD_ENTITY_SET_VISIBLE_STEP,
  AGGREGATOR_ADD_ENTITY_WILL_CANCEL,
  AGGREGATOR_ADD_ENTITY_CLEAR,
  AGGREGATOR_ADD_ENTITY_CLEAR_FORM_VALUES,
  AGGREGATOR_ADD_ENTITY_TERMS_AND_CONDITIONS_REQUEST,
  AGGREGATOR_ADD_ENTITY_TERMS_AND_CONDITIONS_SUCCESS,
  AGGREGATOR_ADD_ENTITY_TERMS_AND_CONDITIONS_FAILURE,
  GET_TINK_URL_REQUEST,
  GET_TINK_URL_SUCCESS,
  GET_TINK_CREATE_USER_BANKS_REQUEST,
  GET_TINK_CREATE_USER_BANKS_SUCCESS,
  GET_TINK_CREATE_USER_BANKS_FAILURE,
  REFRESH_AGGREGATION_TINK_REQUEST,
  REFRESH_AGGREGATION_TINK_SUCCESS,
  REFRESH_AGGREGATION_TINK_FAILURE,
} from 'constants/actionTypes';

function getTinkUrlRequest() {
  return {
    type: GET_TINK_URL_REQUEST,
  };
}

function getTinkUrlSuccess() {
  return {
    type: GET_TINK_URL_SUCCESS,
  };
}

function getCreateUserBanksRequest() {
  return {
    type: GET_TINK_CREATE_USER_BANKS_REQUEST,
  };
}

function getCreateUserBanksSuccess(userBank) {
  return {
    type: GET_TINK_CREATE_USER_BANKS_SUCCESS,
    payload: { userBank },
  };
}

function getCreateUserBanksFailure(error) {
  return {
    type: GET_TINK_CREATE_USER_BANKS_FAILURE,
    payload: {
      error,
    },
  };
}

function refreshAggregationTinkRequest() {
  return {
    type: REFRESH_AGGREGATION_TINK_REQUEST,
  };
}

function refreshAggregationTinkSuccess(data) {
  return {
    type: REFRESH_AGGREGATION_TINK_SUCCESS,
    payload: { data },
  };
}

function refreshAggregationTinkFailure(error) {
  return {
    type: REFRESH_AGGREGATION_TINK_FAILURE,
    payload: {
      error,
    },
  };
}

function getBanksRequest() {
  return {
    type: AGGREGATOR_ADD_ENTITY_GET_BANKS_REQUEST,
  };
}

function getBanksSuccess(banks) {
  return {
    type: AGGREGATOR_ADD_ENTITY_GET_BANKS_SUCCESS,
    payload: {
      banks,
    },
  };
}

function getBanksFailure(error) {
  return {
    type: AGGREGATOR_ADD_ENTITY_GET_BANKS_FAILURE,
    payload: {
      error,
    },
  };
}

function getFormRequest() {
  return {
    type: AGGREGATOR_ADD_ENTITY_GET_FORM_REQUEST,
  };
}

function getFormSuccess(form, code, publicKey, beta, name, logo, psd2Supported, psd2Info) {
  return {
    type: AGGREGATOR_ADD_ENTITY_GET_FORM_SUCCESS,
    payload: {
      form,
      code,
      publicKey,
      beta,
      name,
      logo,
      psd2Supported,
      psd2Info,
    },
  };
}

function getFormFailure(error) {
  return {
    type: AGGREGATOR_ADD_ENTITY_GET_FORM_FAILURE,
    payload: {
      error,
    },
  };
}

function sendFormInfoRequest() {
  return {
    type: AGGREGATOR_ADD_ENTITY_SEND_FORM_INFO_REQUEST,
  };
}

function sendFormInfoSuccess() {
  return {
    type: AGGREGATOR_ADD_ENTITY_SEND_FORM_INFO_SUCCESS,
  };
}

function sendFormInfoFailure(error) {
  return {
    type: AGGREGATOR_ADD_ENTITY_SEND_FORM_INFO_FAILURE,
    payload: {
      error,
    },
  };
}

function selectBank(selectedBank) {
  return {
    type: AGGREGATOR_ADD_ENTITY_SELECT_BANK,
    payload: {
      selectedBank,
    },
  };
}

function validateStep(step) {
  return {
    type: AGGREGATOR_ADD_ENTITY_VALIDATE_STEP,
    payload: {
      step,
    },
  };
}

function setVisibleStep(step) {
  return {
    type: AGGREGATOR_ADD_ENTITY_SET_VISIBLE_STEP,
    payload: {
      step,
    },
  };
}

function setWillCancel() {
  return {
    type: AGGREGATOR_ADD_ENTITY_WILL_CANCEL,
  };
}

function setFormValue(id, value) {
  return {
    type: AGGREGATOR_ADD_ENTITY_SET_FORM_VALUE,
    payload: {
      id,
      value,
    },
  };
}

function clearAddEntity() {
  return {
    type: AGGREGATOR_ADD_ENTITY_CLEAR,
  };
}

function clearFormValues() {
  return {
    type: AGGREGATOR_ADD_ENTITY_CLEAR_FORM_VALUES,
  };
}

function handleTermsAndConditionsRequest() {
  return {
    type: AGGREGATOR_ADD_ENTITY_TERMS_AND_CONDITIONS_REQUEST,
  };
}

function handleTermsAndConditionsFailure() {
  return {
    type: AGGREGATOR_ADD_ENTITY_TERMS_AND_CONDITIONS_FAILURE,
  };
}

function handleTermsAndConditionsSuccess() {
  return {
    type: AGGREGATOR_ADD_ENTITY_TERMS_AND_CONDITIONS_SUCCESS,
  };
}

const parseBanks = (banks, getState) => {
  const AGGREGATOR_V2 = getState().flagBasedFeatures
    ? getState().flagBasedFeatures.get(AGGREGATOR_NEW_FEATURES)
    : false;

  if (AGGREGATOR_V2) {
    return banks.map(b => ({
      id: b.robotCode,
      text: b.frontName,
      url: b.imageUrl,
      showOnGrid: b.showOnGrid,
    }));
  } else {
    return banks.map(b => ({
      id: b.robotName,
      text: b.frontName,
      url: b.imageUrl,
      showOnGrid: b.showOnGrid,
    }));
  }
};

const handleTermsAndConditions = termsAndConditionsData => dispatch => {
  dispatch(handleTermsAndConditionsRequest());

  const requestData = {
    query: {
      termsAndConditionsAccepted: termsAndConditionsData[CHECK_BOX_CHECKED],
      makeOffersThroughAnyChannelAccepted: termsAndConditionsData[MAKE_OFFERS_CHECK_BOX],
      makeOffersThroughThirdPartiesAccepted: termsAndConditionsData[THIRD_PARTIES_CHECK_BOX],
    },
  };
  return APIPatch({
    dispatch,
    endpoint: 'aggregatorHandleConditionsDocument',
    url: apiURLBuilder.getURL('aggregatorHandleConditionsDocument', {
      userId: getPersonTypeAndCodeHashed(),
    }),
    params: requestData,
  })
    .then(() => dispatch(handleTermsAndConditionsSuccess()))
    .catch(() => dispatch(handleTermsAndConditionsFailure()));
};

const handleTermsAndConditionsTink = termsAndConditionsData => dispatch => {
  dispatch(handleTermsAndConditionsRequest());

  const requestData = {
    query: {
      acceptedTerms: {
        userIdThroughAccountVerificationAccepted: true,
        termsAndConditionsAccepted: termsAndConditionsData[CHECK_BOX_CHECKED],
        makeOffersThroughAnyChannelAccepted: termsAndConditionsData[MAKE_OFFERS_CHECK_BOX],
        makeOffersThroughThirdPartiesAccepted: termsAndConditionsData[THIRD_PARTIES_CHECK_BOX],
        channel: 'WEB',
      },
    },
  };
  return APIPatch({
    dispatch,
    endpoint: 'aggregatorHandleConditionsDocumentTink',
    url: apiURLBuilder.getURL('aggregatorHandleConditionsDocumentTink', {
      userId: getPersonTypeAndCodeHashed(),
    }),
    params: requestData,
  })
    .then(() => dispatch(handleTermsAndConditionsSuccess()))
    .catch(() => dispatch(handleTermsAndConditionsFailure()));
};

const getBanks = () => (dispatch, getState) => {
  dispatch(getBanksRequest());

  const AGGREGATOR_V2 = getState().flagBasedFeatures
    ? getState().flagBasedFeatures.get(AGGREGATOR_NEW_FEATURES)
    : false;

  const requestData = AGGREGATOR_V2
    ? {
        query: {
          channel: 'private',
        },
      }
    : {};

  const endPointAggregator = AGGREGATOR_V2 ? 'aggregatorGetBanks' : 'aggregatorGetBanksV1';

  return APIGet({
    dispatch,
    endpoint: endPointAggregator,
    url: apiURLBuilder.getURL(endPointAggregator, requestData),
  })
    .then(response => {
      dispatch(getBanksSuccess(parseBanks(response, getState)));
    })
    .catch(error => {
      dispatch(getBanksFailure({ error: error }));
    });
};

const getDataBank = selectedBankId => (dispatch, getState) => {
  dispatch(getFormRequest());

  const AGGREGATOR_V2 = getState().flagBasedFeatures
    ? getState().flagBasedFeatures.get(AGGREGATOR_NEW_FEATURES)
    : false;
  return APIGet(
    dispatch,
    apiURLBuilder.getURL(
      AGGREGATOR_V2 ? 'aggregatorGetDataBank' : 'aggregatorGetDataBankV1',
      AGGREGATOR_V2 ? { robotCode: selectedBankId } : { bankId: selectedBankId }
    )
  )
    .then(response => {
      const hasData = response.loginData && response.loginData.length;

      if (hasData) {
        dispatch(
          getFormSuccess(
            response.loginData,
            response.code,
            response.publicKey,
            response.beta,
            response.name,
            response.imageUrl,
            response.psd2Supported,
            response.psd2Info
          )
        );
      } else {
        dispatch(getFormFailure({ error: 'Services disconnected' }));
      }
    })
    .catch(error => dispatch(getFormFailure({ error: error })));
};

const sendFormInfo = (publicKey, bankCode, values, userBankId) => (dispatch, getState) => {
  const AGGREGATOR_V2 = getState().flagBasedFeatures
    ? getState().flagBasedFeatures.get(AGGREGATOR_NEW_FEATURES)
    : false;
  const isTinkAggregator =
    getState().flagBasedFeatures && getState().flagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

  let loginParameters = {};
  let concatDataUserBank = '';
  let ordered = {};

  let requestData;
  let uid;
  let form;

  uid = values.find((v, k) => ['dni', 'id', 'docnumber', 'user'].includes(k.toLowerCase()));
  form = values
    .map((f, k) => ({ name: k, value: cipherWithPublicKey(f, publicKey) }))
    .valueSeq()
    .toJS();

  if (values) {
    Object.keys(values.toJS())
      .sort()
      .forEach(function (key) {
        ordered[key] = values.toJS()[key];
      });
  }

  fromJS(ordered).map((f, k) => {
    Object.assign(loginParameters, { [k]: cipherWithPublicKey(f, publicKey) });
    concatDataUserBank += f ? f : '';
  });

  if (AGGREGATOR_V2) {
    requestData = !userBankId
      ? {
          query: {
            bankCode,
            credentialsSignature: sha512((concatDataUserBank || '').toUpperCase()),
            loginParameters,
          },
        }
      : {
          query: {
            credentialsSignature: sha512((concatDataUserBank || '').toUpperCase()),
            loginParameters,
          },
        };
  } else {
    requestData = {
      query: {
        uid: sha512((uid || '').toUpperCase()),
        code: bankCode,
        form,
        userBankId,
      },
    };
  }

  dispatch(sendFormInfoRequest());

  if (AGGREGATOR_V2) {
    if (!userBankId) {
      return APIPost(
        dispatch,
        apiURLBuilder.getURL('aggregatorSubmitCredentials', {
          userId: getPersonTypeAndCodeHashed(),
        }),
        requestData
      )
        .then(() => {
          dispatch(sendFormInfoSuccess());
        })
        .then(() => dispatch(isTinkAggregator ? getGlobalPositionTink() : getEntitiesData()))
        .catch(error => dispatch(sendFormInfoFailure({ error: error })));
    } else {
      return APIPatch(
        dispatch,
        apiURLBuilder.getURL('aggregatorRefreshCredentials', {
          userId: getPersonTypeAndCodeHashed(),
          userBankId,
        }),
        requestData
      )
        .then(() => {
          dispatch(sendFormInfoSuccess());
        })
        .then(() => dispatch(isTinkAggregator ? getGlobalPositionTink() : getEntitiesData()))
        .catch(error => dispatch(sendFormInfoFailure({ error: error })));
    }
  } else {
    return APIPost(
      dispatch,
      apiURLBuilder.getURL(
        !userBankId ? 'aggregatorSubmitCredentialsV1' : 'aggregatorRefreshCredentialsV1'
      ),
      requestData
    )
      .then(() => {
        dispatch(sendFormInfoSuccess());
      })
      .then(() => dispatch(isTinkAggregator ? getGlobalPositionTink() : getEntitiesData()))
      .catch(error => dispatch(sendFormInfoFailure({ error: error })));
  }
};

const getTinkUrl = (bankId, userBankId) => (dispatch, getState) => {
  const language = getLanguage();


  dispatch(getTinkUrlRequest());

  return APIPost(dispatch, apiURLBuilder.getURL('aggregatorGetTinkLink'), {
    header: {
      applicationLocale: language,
    },
    query: {
      callback: `${window.location.origin}${window.location.pathname}`,
      tinkBankCode: bankId,
      userBankId,
    },
  })
    .then(response => {
      dispatch(getTinkUrlSuccess());
      window.location.replace(response.tinkLinkUrl);
      dispatch(getBanksSuccess(parseBanks(response, getState)));
    })
    .catch(error => {
      dispatch(getBanksFailure({ error: error }));
    });
};

const getCreateUserBanksTink = (credentialId, state) => dispatch => {
  dispatch(getCreateUserBanksRequest());

  const endPointAggregator = 'aggregatorGetCreateUserBanksTink';

  return APIPost(dispatch, apiURLBuilder.getURL(endPointAggregator), {
    query: { credentialId, state },
  })
    .then(response => {
      dispatch(getCreateUserBanksSuccess(response));
    })
    .catch(error => {
      dispatch(getCreateUserBanksFailure({ error: error }));
    });
};

const refreshAggregationTink = userBankId => dispatch => {
  const endPointAggregator = 'aggregatorRefreshTink';

  const url = apiURLBuilder.getURL(endPointAggregator, { userBankId });

  dispatch(refreshAggregationTinkRequest());

  return APIPost({
    dispatch,
    endpoint: endPointAggregator,
    url,
  })
    .then(response => {
      dispatch(refreshAggregationTinkSuccess(response));
    })
    .catch(error => {
      dispatch(refreshAggregationTinkFailure({ error: error }));
    });
};

const getBanksTink = () => (dispatch, getState) => {
  dispatch(getBanksRequest());

  const endPointAggregator = 'aggregatorGetBanksTink';

  return APIGet({
    dispatch,
    endpoint: endPointAggregator,
    url: apiURLBuilder.getURL(endPointAggregator),
  })
    .then(response => {
      dispatch(getBanksSuccess(response, getState));
    })
    .catch(error => {
      dispatch(getBanksFailure({ error: error }));
    });
};

export {
  getBanks,
  getDataBank,
  clearAddEntity,
  selectBank,
  sendFormInfo,
  setVisibleStep,
  validateStep,
  setWillCancel,
  setFormValue,
  clearFormValues,
  handleTermsAndConditions,
  handleTermsAndConditionsTink,
  getTinkUrl,
  getCreateUserBanksTink,
  refreshAggregationTink,
  getBanksTink,
};
